<template>
    <div class="checkbox-wrap-container" @click.prevent='clickBox'>
        <label role="checkbox" :class="['checkbox-wrap', type]" :disabled="disabled">
            <input
                class="checkbox-original"
                type="checkbox"
                v-model="checked"
                :disabled="disabled"
                ref="checkbox"
                @change="updateValue"
                @click='clickBox'
            />
            <span :class="[checked ? 'checked' : (indeterminate ? 'indeterminate' : 'no-checked'), 'reo-checkbox', type, size,{'disabled':disabled}]" v-show="!myOnlyLabel">
                <span :class="[indeterminate ? '': checkIcon, 'check-icon']"></span>
            </span>
            <span :class="['checkbox-label', {'underline': myOnlyLabel, 'label-check': checked}, color]" v-if="label">{{ (labelOnSelect && checked) ? labelOnSelect : label}}</span>
        </label>
        <span class="text" v-if="text" v-html="text"></span>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({

    props: {

        value: {

            required: true

        },

        indeterminate: Boolean,

        type: {

            type: String,
            validator ( type: string ): boolean {

                let types = ['fill', 'original', 'circle'];
                return types.includes( type );

            },
            default () {

                return 'original';

            }

        },

        label: {

            type: String

        },

        labelOnSelect: {

            type: String

        },

        onlyLabel: {

            default (): boolean {

                return false;

            }

        },

        color: String,

        size: {

            type: String,
            validator ( type: string ): boolean {

                let types = ['small', 'middle'];
                return types.includes( type );

            },
            default () {

                return 'middle';

            }

        },

        text: String,

        disabled: {

            type: Boolean,
            default () {

                return false;

            }

        }

    },

    data () {

        return {

            checked: this.value,

        };

    },

    methods: {

        updateValue () {

            this.$emit( 'input', this.checked );

        },

        clickBox () {

            if ( this.disabled ) {

                return false;

            }
            this.checked = !this.checked;
            this.updateValue();

        },
        clearBox () {

            this.checked = false;
            this.updateValue();

        },
        checkBox () {

            this.checked = true;
            this.updateValue();

        }

    },

    watch: {

        value ( value ) {

            this.checked = value;

        }

    },

    computed: {

        myOnlyLabel () {

            if ( typeof this.onlyLabel === 'string' ) {

                return true;

            } else {

                return false;

            }

        },
        checkIcon () {

            let type = this.type;
            if ( type === 'circle' ) {

                return 'circle-check';

            } else {

                return 'icon-check';

            }

        }

    }

});
</script>

<style lang="less" scoped>
    .checkbox-wrap-container{
        display: inline-block;
    }
    .checkbox-wrap{
        display: inline-block;
        cursor: pointer;
        user-select: none;
        &[disabled]{
            cursor: not-allowed;
        }
    }
    .reo-checkbox{
        display: inline-block;
        box-sizing: border-box;
        width: .2rem;
        height: .2rem;
        border: 2px solid @brand_light;
        background-color: transparent;
        position: relative;
        vertical-align: middle;
        font-size: .16rem;
        border-radius: 4px;
        &.circle{
            border-radius: 100%;
        }
        &:not(.checked) .check-icon{
            display: none;
        }
        .check-icon{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
        }
        .circle-check{
            transform: none;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            display: block;
            height: auto;
            width: auto;
            border: none;
            background-color: @brand_light;
            border-radius: 100%;
            margin: 3px;
        }
        &.fill{
            .check-icon{
                color: #fff;
            }
        }
        &.small{
            width: .16rem;
            height: .16rem;
            font-size: 14px;
            // border-radius: 2px;
        }
        @media @snapeak_mobile{
            &{
                width: 24px;
                height: 24px;
            }
            &.small{
                width: 22px;
                height: 22px;
                // border-radius: 0.04rem;
            }
            .check-icon{
                font-size: 16px;
            }
            &.small .check-icon{
                font-size: 22px;
            }
            &.small.circle,
            &.circle{
                width: 0.34rem;
                height: 0.34rem;
                border-radius: 100%;
                .circle-check{
                    margin: 0.04rem;
                }
            }
        }
    }
    .reo-checkbox.original{
        border-color: #454545;
        background-color: #fff;
        @media @snapeak_pc{
            &:hover{
                border-color: @brand_light_hover;
            }
        }
    }
    .reo-checkbox.fill{
        @media @snapeak_pc{
            &:hover{
                background-color: @brand_light;
            }
        }
    }
    .reo-checkbox.checked{
        background-color: @brand_light;
        border-color: @brand_light;
    }
    .reo-checkbox.checked.fill{
        background: @brand_light;
        border: none;
    }

    .reo-checkbox.indeterminate {
        background-color: @brand_light;
        border: none;
        position: relative;
    }
    .reo-checkbox.indeterminate .check-icon {
        display: block;
        width: 60%;
        height: 2px;
        background-color: #fff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .reo-checkbox.disabled{
        background-color: #171717;
        border-color: @disable;
        .check-icon{
            color: @disable;
        }
        &.checked{
            .check-icon{
                color: rgba(#80B9A0, 0.6);
            }
            background-color: rgba(@brand_light, 0.4);
            border-color: transparent;
        }
    }
    .checkbox-original{
        opacity: 0;
        outline: none;
        position: absolute;
        margin: 0;
        width: 0;
        height: 0;
        z-index: -1;
    }
    .checkbox-label{
        color: @brand_light;
        font-size: 14px;
        font-weight: 500;
        line-height: 21px;
        vertical-align: middle;
        margin-left: 6px;
        @media @snapeak_mobile{
            font-size: 12px;
            line-height: 12px;
        }
        &.underline{
            margin-left: 0;
            &.label-check{
                text-decoration: underline;
            }
        }
        &.primary{
            color: @font_primary;
        }
    }

    .text{
        margin-left: 0.1rem;
        font-size: 14px;
        vertical-align: middle;
        @media @snapeak_mobile{
            font-size: 12px;
        }
    }
</style>
